function lazyLoadVideos(selector, { scope = document, threshold = 0.25, autoplay = false } = {}) {
    const vids = typeof selector === 'string' ? scope.querySelectorAll(selector) : selector;
    if (!vids || !vids.length) return;

    const hydrate = (video) => {
        // poster
        const poster = video.getAttribute('data-poster');
        if (poster && !video.poster) video.poster = poster;

        // sources: supports data-src, data-src-mobile, data-src-desktop
        const isMobile = window.matchMedia('(max-width:768px)').matches;
        video.querySelectorAll('source').forEach(s => {
            const src = isMobile ? (s.dataset.srcMobile || s.dataset.src) : (s.dataset.srcDesktop || s.dataset.src);
            if (src) s.src = src;
        });

        video.load();

        if (autoplay || video.autoplay) {
            video.muted = true;
            video.playsInline = true;
            video.setAttribute('webkit-playsinline', '');
            video.play().catch(() => {});
        }
    };

    if (!('IntersectionObserver' in window)) { vids.forEach(hydrate); return; }

    const io = new IntersectionObserver((entries) => {
        entries.forEach(({ isIntersecting, target }) => {
            if (isIntersecting) {
                hydrate(target);
                io.unobserve(target);
            }
        });
    }, { threshold });

    vids.forEach(v => io.observe(v));
}